import { render } from "./MarketingCampaignParticipantsPanel.vue?vue&type=template&id=37cdbcd2&scoped=true"
import script from "./MarketingCampaignParticipantsPanel.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignParticipantsPanel.vue?vue&type=script&lang=js"

import "./MarketingCampaignParticipantsPanel.vue?vue&type=style&index=0&id=37cdbcd2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37cdbcd2"]])

export default __exports__